<!-- Begin page -->
<div id="layout-wrapper">
    <!-- Top Bar -->
    <app-topbar></app-topbar>
    <app-pattern></app-pattern>
    <div class="main-content">

        <div class="page-content">
            <div class="container-fluid">
                <!-- Main Content -->
                <router-outlet></router-outlet>
            </div>
        </div>
        <!-- Footer -->
        <app-footer></app-footer>
    </div>
</div>